import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CardMaisFiltros from './CardMaisFiltros.vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import CustomChip from '@/views/components/CustomChip.vue';
import { OPERADORES } from '@/constants/operadores';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';
interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const { query } = useRoute();

onMounted(() => {
  if (query.dePesquisaTermos) {
    filtroLegislacao.value = {
      ...filtroLegislacao.value,
      dePesquisaTermos: `${query.dePesquisaTermos}`.replace(/^"(.*)"$/, '$1'),
    };
  }
});

const store = ConsultaLegislacaoStore();
const { filtroLegislacao } = storeToRefs(store);

const consultar = () => {
  store.limparDataOptions();
  store.consultaListaLegislacao(true);
};

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filtroLegislacao.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filtroLegislacao.value = {
    ...filtroLegislacao.value,
    dePesquisaTermos: dePesquisa,
  };
};

return { __sfc: true,query, store, filtroLegislacao, consultar, handleClickTermos, CardMaisFiltros, CustomChip, OPERADORES }
}

})